import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { Row } from '@/lib/supabase/supabase.interface'

export interface INotificationsState {
  notifications: Row<'Notification'>[]
}

const initialState: INotificationsState = {
  notifications: []
}

const notificatoinsSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    setNotifications: (
      state,
      action: PayloadAction<Row<'Notification'>[] | []>
    ) => {
      // @ts-ignore
      state.notifications = action.payload
    },
    clearNotifications: () => {
      return initialState
    }
  }
})

export const { setNotifications, clearNotifications } =
  notificatoinsSlice.actions
export default notificatoinsSlice.reducer
